/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const MeterFrameState = {
    NotSpecified: 'NotSpecified',
    Active: 'Active',
    Inactive: 'Inactive',
} as const;
export type MeterFrameState = typeof MeterFrameState[keyof typeof MeterFrameState];

